import {setUserData} from "@/helpers/Utils";

export default {
  namespaced: true,
  state: {
    user: {
      id: 1,
      last_addr: '127.0.0.1', // last login IP
      last_time: '', // last login
      member: 1, // member ID
      username: null,
      role: 'superadmin', // superadmin, memberadmin, member,
      level: 1, // 1:superadmin, 2: memberadmin, 3: normal user,
      user_mail: 'the.user.email@gmail.com',
      user_telegram: '',
      user_type: 1, // don't know what this is
      company: {
        NIB: 123123123,
        NPWP: '123.123.1.123.1.1222',
        chat: 123123123123, // don't know what this is
        conmpany_name: 'ROYAL UNION',
        expiry: '2202-12-12', // membership expiry date
        id: 1,
        member_since: '2020-12-12',
        nib_img: '',
        npwp_img: '',
        renewal: '', // when to renew the license
        status: 1, // 1: active, 0: inactive
        user_telegram: '',
      },
      // abilities: [],
    },
  },
  getters: {
    isSuperAdmin: state => state.user.role === 'superadmin' && state.user.level === 1 && state.user.company === null ,
    isAdmin: state => state.user.level <= 2 && ['superadmin', 'memberadmin', ].includes(state.user.role)
  },
  mutations: {
    SET_USER(state, user){
      state.user = user;
    },
  },
  actions: {
    USER_LOGGED_IN({ commit }, user) {
      const roles = {
        1: 'superadmin',
        2: 'memberadmin',
        3: 'member',
        4: 'control_room',
        5: 'gate_pass',
      }
      user.role = roles[user.level]
      if (user.company !== null) {
        user.role = user.level < 3 ? roles[2] : roles[3]
      }
      commit('SET_USER', user)
      setUserData(user);
    }
  },
}
